export default "__VITE_PUBLIC_ASSET__12daa5e8__"